import { render, staticRenderFns } from "./EmptyResultLaudo.vue?vue&type=template&id=024e1a1c&scoped=true&lang=pug"
import script from "./EmptyResultLaudo.vue?vue&type=script&lang=js"
export * from "./EmptyResultLaudo.vue?vue&type=script&lang=js"
import style0 from "./EmptyResultLaudo.vue?vue&type=style&index=0&id=024e1a1c&prod&lang=scss&scoped=true"
import style1 from "./EmptyResultLaudo.vue?vue&type=style&index=1&id=024e1a1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024e1a1c",
  null
  
)

export default component.exports